import { SortOrder } from '@els/els-react--table';

function toNum(v) {
  const numericValue = typeof v === 'string' ? parseFloat(v) : v;
  return Number.isFinite(numericValue) ? numericValue : 0;
}

// FR-3.3: blank yields always sort to the bottom regardless of direction. With the
// table data pre-ordered by rank ascending, JS stable sort keeps rank-ascending as the
// secondary key among blank-yield rows.
export function conditionsSortFn(leftValue, rightValue, direction, columnKey) {
  if (columnKey === 'yieldPercent') {
    const leftEmpty = leftValue == null || leftValue === '';
    const rightEmpty = rightValue == null || rightValue === '';
    if (leftEmpty && rightEmpty) return 0;
    if (leftEmpty) return 1;
    if (rightEmpty) return -1;
  }
  const diff = toNum(leftValue) - toNum(rightValue);
  return direction === SortOrder.DESC ? -diff : diff;
}

export function compareRank(left, right) {
  return toNum(left) - toNum(right);
}
